import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Rocket, Settings, Code2 } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

const sections = [
  {
    icon: Rocket,
    title: "Getting started",
    items: [
      "Quickstart in 5 minutes",
      "Choose your sources: X (Twitter), LinkedIn & Reddit",
      "Create your first campaign",
      "Train your brand voice",
    ],
  },
  {
    icon: Settings,
    title: "Workspace & teams",
    items: [
      "Inviting teammates",
      "Roles and permissions",
      "Approval queue setup",
      "Slack & email notifications",
    ],
  },
  {
    icon: BookOpen,
    title: "Concepts",
    items: [
      "Intent scoring explained",
      "ICP fit and disqualifiers",
      "Brand voice training data",
      "Reply Agent guardrails",
    ],
  },
  {
    icon: Code2,
    title: "Integrations & API",
    items: [
      "HubSpot integration",
      "Notion integration",
      "Webhooks reference",
      "REST API reference",
    ],
  },
];

export default function Docs() {
  return (
    <MarketingPage
      seo={{
        title: "Docs — Collavue documentation, guides, and API reference",
        description:
          "Everything you need to ship with Collavue. Quickstart guides, concepts, integrations, and the REST API reference.",
        path: "/docs",
        keywords:
          "Collavue docs, Collavue API, Collavue documentation, X lead API, Twitter lead API, LinkedIn lead API, social listening API",
      }}
    >
      <PageHero
        eyebrow="Documentation"
        title="Build, integrate, and scale with"
        italicWord="Collavue."
        description="Step-by-step guides, concept explainers, and a fully documented REST API."
      />

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-5">
          {sections.map((s) => (
            <div key={s.title} className="rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40">
              <s.icon className="w-6 h-6 text-[#2d5bff]" />
              <h3 className="font-display text-xl text-[#0a1736] font-semibold mt-3">{s.title}</h3>
              <ul className="mt-4 space-y-2 text-sm text-[#1c2a4d]">
                {s.items.map((i) => (
                  <li key={i} className="hover:text-[#2d5bff] cursor-pointer">{i}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="max-w-7xl mx-auto px-6 pb-20">
          <p className="text-sm text-[#5a6478]">
            Looking for something else?{" "}
            <Link to="/about" className="text-[#2d5bff] hover:underline">Contact our team</Link>.
          </p>
        </div>
      </section>
    </MarketingPage>
  );
}
